var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path Copy"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Home-1","transform":"translate(-975.000000, -3400.000000)","fill":"#002D58"},React.createElement("polygon",{"id":"Path-Copy","points":"988.519345 3400 987.124596 3401.36908 989.453654 3404.00163 975 3404.00163 975 3406.03291 989.453654 3406.03291 987.124596 3408.6167 988.519345 3410 993 3404.97461"})))]);
}

Arrow.defaultProps = {"width":"18px","height":"10px","viewBox":"0 0 18 10","version":"1.1"};

module.exports = Arrow;

Arrow.default = Arrow;
